module.exports = __webpack_public_path__ + "static/media/klub-logo.d1362d26.png";